import { ContentType, UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const ImageUploader = (user: UserLoginType, formData: any) => {
  return new Promise<{ data: ContentType }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `content`,
      header: {
        Authorization: "Bearer " + user?.accessToken,
        "Content-Type": "multipart/form-data"
      },
      body: formData
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertImageToContent(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertImageToContent = (item: any): ContentType => {
  return {
    id: item.id,
    link: `https://api.mahdibookshop.com/${item?.path?.replace("uploads/", "")}`,
    path: item.path,
    created_at: item.created_at
  };
};

